"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acquireFileFromDrive = acquireFileFromDrive;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ActionTypes = require("./ActionTypes");

var _Constants = require("../Constants");

var FileApi = _interopRequireWildcard(require("../api/Files"));

function acquireFileFromDrive(file, folder, uploadedFileAccess) {
  return function (dispatch, getState, httpClient) {
    var fileDownloadOptions = {
      name: file.name,
      authorization: file.authorization
    };

    if (folder) {
      fileDownloadOptions.folderId = folder.get('id');
    }

    dispatch({
      type: _ActionTypes.DOWNLOAD_FROM_DRIVE_ATTEMPTED,
      meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
        name: 'Manage Files',
        eventKey: 'fileManagerManageFiles',
        action: 'upload-drive-attempt'
      })
    });
    return FileApi.downloadFromUrl(fileDownloadOptions, file.url, uploadedFileAccess, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.DOWNLOAD_FROM_DRIVE_SUCCEEDED,
        file: data,
        meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
          name: 'Manage Files',
          eventKey: 'fileManagerManageFiles',
          action: 'upload-drive-success'
        })
      });
    }).catch(function (data) {
      var message = _I18n.default.text('FileManagerCore.notifications.upload.error.message', {
        filename: data.name
      });

      dispatch({
        type: _ActionTypes.DOWNLOAD_FROM_DRIVE_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.upload.error.title'),
            message: message
          },
          error: data
        }
      });
    });
  };
}